const manutencao_de_parametro_grupo_de_atendimento = {
  path: "/manutencao-de-parametro-grupo-de-atendimento",
  redirect: "/manutencao-de-parametro-grupo-de-atendimento",
  meta: {
    breadCrumb: "Gerenciador de Parâmetro - Parâmetros de Atendimento",
  },
  children: [
    {
      path: "/manutencao-de-parametro-grupo-de-atendimento",
      name: "/manutencao-de-parametro-grupo-de-atendimento",
      meta: {
        allowedPermissions: ["parametros_atendimento_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroGrupoAtendimento/ManutencaoDeParametroDeGrupoAtendimentoHome.vue"
        ),
    },
    {
      path: "/manutencao-de-parametro-grupo-de-atendimento/novo",
      name: "manutencao-de-parametro-grupo-de-atendimento-novo",
      meta: {
        allowedPermissions: ["parametros_atendimento_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroGrupoAtendimento/ManutencaoDeParametroDeGrupoAtendimentoCad.vue"
        ),
    },
    {
      path: "/manutencao-de-parametro-grupo-de-atendimento/edit/:id",
      name: "manutencao-de-parametro-grupo-de-atendimento-atualizar",
      meta: {
        allowedPermissions: ["parametros_atendimento_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeParametroGrupoAtendimento/ManutencaoDeParametroDeGrupoAtendimentoEdit.vue"
        ),
    },
    /*
    {
      path: "/manutencao-de-parametro-grupo-de-atendimento",
      name: "/manutencao_de_parametro_grupo_de_atendimento",
      component: () =>
        import(
          "@/views/ManutencaoDeParametroGrupoAtendimento/ManutencaoDeParametroDeGrupoAtendimentoHome.vue"
        ),
    }, */
  ],
};

export { manutencao_de_parametro_grupo_de_atendimento };
